var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 483,
    viewBox: "0 0 483 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.001 241.526C415.996 276.039 405.757 309.775 386.578 338.469C367.399 367.162 340.143 389.524 308.255 402.727C276.367 415.93 241.281 419.38 207.432 412.642C173.583 405.904 142.493 389.279 118.092 364.871C93.6917 340.464 77.0769 309.368 70.3489 275.517C63.6209 241.667 67.0818 206.581 80.2941 174.697C93.5064 142.814 115.877 115.564 144.576 96.3938C173.275 77.2239 207.015 66.9947 241.527 66.9999",
    stroke: "#44BBCF",
    strokeWidth: 95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.317 211.012C419.347 244.994 415.164 280.001 401.299 311.606C387.433 343.211 364.507 369.995 335.419 388.57C306.331 407.145 272.388 416.678 237.883 415.962C203.378 415.247 169.859 404.315 141.567 384.55C113.274 364.785 91.4776 337.074 78.9341 304.921C66.3905 272.769 63.663 237.618 71.0965 203.916C78.5299 170.213 95.7905 139.471 120.696 115.578C145.601 91.685 177.031 75.7137 211.013 69.6838",
    stroke: "#46A69B",
    strokeWidth: 95
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.959 160.303C412.018 190.852 418.658 225.477 415.039 259.8C411.419 294.122 397.703 326.601 375.625 353.128C353.548 379.655 324.099 399.04 291.004 408.831C257.909 418.622 222.654 418.379 189.697 408.133C156.74 397.887 127.562 378.099 105.851 351.27C84.1407 324.441 70.8735 291.777 67.7273 257.408C64.5811 223.038 71.6972 188.508 88.1756 158.183C104.654 127.858 129.755 103.101 160.304 87.0418",
    stroke: "#6EC4A1",
    strokeWidth: 95
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M335.539 94.5069C364.611 113.106 387.516 139.908 401.355 171.525C415.195 203.141 419.349 238.152 413.291 272.129C407.233 306.106 391.236 337.523 367.323 362.409C343.409 387.294 312.653 404.529 278.945 411.935C245.236 419.341 210.088 416.585 177.945 404.015C145.803 391.445 118.11 369.626 98.3678 341.317C78.6259 313.008 67.7219 279.481 67.0346 244.975C66.3474 210.469 75.9078 176.534 94.5069 147.461",
    stroke: "#B8EBD2",
    strokeWidth: 95
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.5 66.9999C276.013 66.9999 309.751 77.2342 338.447 96.4085C367.143 115.583 389.509 142.836 402.717 174.722C415.924 206.607 419.38 241.694 412.647 275.543C405.914 309.393 389.294 340.486 364.89 364.89C340.486 389.294 309.393 405.914 275.543 412.647C241.694 419.38 206.607 415.924 174.722 402.717C142.836 389.509 115.583 367.143 96.4085 338.447C77.2342 309.751 67 276.013 67 241.5",
    stroke: "#71B54D",
    strokeWidth: 95
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07 231.724C265.382 229.032 262.132 227.685 258.322 227.685C254.509 227.685 251.26 229.032 248.571 231.724C245.881 234.415 244.538 237.651 244.538 241.429C244.538 245.26 245.881 248.535 248.571 251.253C251.26 253.971 254.509 255.329 258.322 255.329C262.132 255.329 265.382 253.971 268.07 251.253C270.76 248.535 272.104 245.26 272.104 241.429C272.104 237.651 270.76 234.415 268.07 231.724ZM273.198 255.954C269.085 260.015 264.112 262.045 258.282 262.045C252.504 262.045 247.557 260.015 243.445 255.954C239.331 251.893 237.275 247 237.275 241.272C237.275 235.65 239.331 230.861 243.445 226.904C247.557 222.948 252.504 220.969 258.282 220.969C264.112 220.969 269.085 222.948 273.198 226.904C277.31 230.861 279.367 235.65 279.367 241.272C279.367 247 277.31 251.893 273.198 255.954V255.954ZM215.332 227.685C211.634 227.685 208.576 228.992 206.156 231.606C203.735 234.221 202.525 237.495 202.525 241.429C202.525 245.209 203.76 248.47 206.234 251.214C208.706 253.958 211.661 255.329 215.097 255.329C217.441 255.329 219.627 254.686 221.657 253.398C223.688 252.11 225.223 250.359 226.265 248.145H234.386C232.928 252.414 230.481 255.798 227.046 258.297C223.609 260.796 219.652 262.045 215.175 262.045C209.553 262.045 204.829 260.067 201.002 256.11C197.175 252.154 195.262 247.26 195.262 241.429C195.262 235.702 197.188 230.861 201.041 226.904C204.893 222.948 209.656 220.969 215.332 220.969C219.808 220.969 223.856 222.31 227.474 224.991C231.093 227.672 233.397 231.017 234.386 235.025H226.265C223.557 230.133 219.912 227.685 215.332 227.685ZM180.621 230.809C178.147 228.518 175.271 227.373 171.991 227.373C168.087 227.373 164.885 228.778 162.386 231.589C160.824 233.36 159.808 235.859 159.34 239.086H184.564C184.408 235.859 183.093 233.1 180.621 230.809V230.809ZM191.593 244.708H159.34C160.121 247.913 161.67 250.485 163.987 252.422C166.303 254.36 169.05 255.329 172.226 255.329C177.015 255.329 180.685 253.143 183.236 248.769H190.577C189.119 252.83 186.698 256.059 183.314 258.453C179.929 260.848 176.131 262.045 171.913 262.045C166.447 262.045 161.761 260.028 157.856 255.993C153.952 251.96 152 247.104 152 241.429C152 235.702 153.952 230.809 157.856 226.747C161.761 222.687 166.498 220.657 172.069 220.657C177.483 220.657 182.13 222.648 186.009 226.63C189.887 230.613 191.827 235.39 191.827 240.96C191.827 241.794 191.749 243.043 191.593 244.708",
    fill: "url(#paint0_linear_1_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M329.407 243V247.408H326.323V243L322.713 235.307H326.069L327.866 240.168L329.679 235.307H333L329.407 243ZM317.305 239.062L316.036 243.199H318.557L317.305 239.062ZM319.973 247.408L319.392 245.648H315.183L314.548 247.408H311.227L316.073 235.307H318.522L323.329 247.408H319.973ZM308.307 247.408H305.586L303.753 239.588L301.921 247.408H299.144L296.023 235.307H299.162L300.777 243.18L302.574 235.307H304.951L306.728 243.217L308.38 235.307H311.518L308.307 247.408Z",
    fill: "url(#paint1_linear_1_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.477 250.958L263.082 239.944H259.411L260.459 232.339L254.166 242.828H257.575L255.477 250.958Z",
    fill: "url(#paint2_linear_1_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.739 209H259.672V217.13H255.739V209Z",
    fill: "url(#paint3_linear_1_2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.75 239.421H290.879V243.354H282.75V239.421Z",
    fill: "url(#paint4_linear_1_2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.547 214.986L242.954 213.019L247.019 220.059L243.612 222.026L239.547 214.986Z",
    fill: "url(#paint5_linear_1_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.192 214.359L272.845 212.414L268.852 219.377L272.199 221.322L276.192 214.359Z",
    fill: "url(#paint6_linear_1_2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.183 226.757L285.257 223.399L278.316 227.433L280.242 230.791L287.183 226.757Z",
    fill: "url(#paint7_linear_1_2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.698 265.644H259.631V273.774H255.698V265.644Z",
    fill: "url(#paint8_linear_1_2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.481 267.787L242.893 269.754L246.962 262.714L243.551 260.747L239.481 267.787Z",
    fill: "url(#paint9_linear_1_2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.174 268.415L272.823 270.36L268.824 263.398L272.175 261.452L276.174 268.415Z",
    fill: "url(#paint10_linear_1_2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.177 256.016L285.249 259.375L278.3 255.341L280.229 251.982L287.177 256.016Z",
    fill: "url(#paint11_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 262.615,
    y1: 243.37,
    x2: 192.186,
    y2: 287.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2",
    x1: 328.137,
    y1: 241.948,
    x2: 307.607,
    y2: 254.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 261.909,
    y1: 242.557,
    x2: 255.073,
    y2: 243.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 259.155,
    y1: 213.462,
    x2: 256.14,
    y2: 213.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 289.81,
    y1: 241.579,
    x2: 284.478,
    y2: 243.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 246.036,
    y1: 217.962,
    x2: 240.415,
    y2: 218.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 275.227,
    y1: 217.302,
    x2: 269.703,
    y2: 218.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_2",
    x1: 286.017,
    y1: 227.455,
    x2: 279.546,
    y2: 229.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_2",
    x1: 259.114,
    y1: 270.106,
    x2: 256.099,
    y2: 270.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2",
    x1: 245.978,
    y1: 265.69,
    x2: 240.351,
    y2: 266.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2",
    x1: 275.207,
    y1: 266.341,
    x2: 269.677,
    y2: 267.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_2",
    x1: 286.01,
    y1: 256.039,
    x2: 279.532,
    y2: 257.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.820ce228e71932c6c405f2bbb7d710da.svg";
export { ForwardRef as ReactComponent };